import { authAxios } from "./axiosClient";
import { ReportDataDescription } from "../constants";

export const getReportDescription = (params = {}) => {
  const url = ReportDataDescription;
  return authAxios().get(url, { params });
};

export const downloadReportDescription = (params = {}) => {
  const url = ReportDataDescription;
  return authAxios().get(url, { params, responseType: "blob" });
};